import React from 'react';
import BoxStep from '../../../common/BoxStep';
import { OrderSummaryItem } from '../../StepSummary/views/OrderSummaryItem';
import {
  getDiscount,
  getPrice,
  getPricePerDay,
  getPricePerDayBeforeDiscount,
  getPriceWithoutDiscounts,
  getSelectedDietCaloriesData,
  getSelectedSideOrdersPrice,
} from '../../../../utils/orderFormPrices';
import { parsePrice } from '../../../../utils';
import {
  getDiscountAmount,
  getOrderForm,
} from '../../../../redux/selectors/orderFormSelector';
import { getPromoCode } from '../../../../redux/selectors/basketSelector';
import { getSelectedCity } from '../../../../redux/selectors/summaryReducer.selectors';
import { getSideOrdersReducer } from '../../../../redux/selectors/sideOrdersSelector';
import NextStepButton from './NextStepButton';
import { useAppSelector } from '../../../../config/hooks';

const SecondStepSideBar = ({ isSummaryBarDisplayed, setValidationStatus }) => {
  const orderForm = useAppSelector(getOrderForm);
  const selectedCity = useAppSelector(getSelectedCity);
  const promoCode = useAppSelector(getPromoCode);
  const sideOrdersReducer = useAppSelector(getSideOrdersReducer);
  const discountAmount = useAppSelector(getDiscountAmount);

  const {
    days,
    mealExchange: { days: customDays },
    selectedDiet,
    selectedDietCaloriesIdPrices,
    selectedSideOrders,
    sets,
    testOrder,
  } = orderForm || {};

  const { code } = promoCode || {};

  const { sectorId } = selectedCity || {};

  return (
    <aside className="steps-page__aside">
      <BoxStep borderTitle smallPaddings smallTitle title="Twoje zamówienie">
        <OrderSummaryItem
          item={orderForm}
          itemDietPrice={getPrice(orderForm, code, sectorId)}
          itemDietPricePerDay={getPricePerDay(orderForm, code, sectorId)}
          itemSideOrdersPrice={getSelectedSideOrdersPrice(customDays, sets)}
        />
      </BoxStep>

      <div className="steps-page-second__summary">
        <BoxStep borderTitle smallPaddings smallTitle title="Podsumowanie">
          <div className="display-flex justify-content-space-between spacer-top-18 spacer-bottom-24">
            <span className="body-m color-gray-800">Liczba dni</span>

            <span className="label-m">{days}</span>
          </div>

          <div className="display-flex justify-content-space-between spacer-top-24 spacer-bottom-24">
            <span className="body-m color-gray-800">Liczba zestawów</span>

            <span className="label-m">{sets}</span>
          </div>

          {getSelectedDietCaloriesData(
            selectedDietCaloriesIdPrices,
            sectorId
          ) && (
            <>
              <div className="display-flex justify-content-space-between spacer-bottom-8">
                <span className="body-m color-gray-800">Cena łącznie</span>

                <span className="label-m">
                  {parsePrice(getPrice(orderForm, code, sectorId) / sets)} zł
                </span>
              </div>

              <div className="display-flex justify-content-space-between spacer-bottom-24 bg-color-gray-100 padding-all-4 border-radius-default">
                <span className="label-s color-gray-400">Cena za dzień</span>

                <span className="label-s color-gray-400">
                  {parsePrice(getPricePerDay(orderForm, code, sectorId))} zł
                </span>
              </div>
            </>
          )}

          {sideOrdersReducer && sideOrdersReducer?.length > 0 && (
            <div className="display-flex justify-content-space-between spacer-bottom-24">
              <span className="body-m color-gray-800">Dodatki łącznie</span>

              <span className="label-m">
                {parsePrice(getSelectedSideOrdersPrice(customDays, sets))} zł
              </span>
            </div>
          )}

          {getDiscount(
            getPricePerDayBeforeDiscount(orderForm, sectorId),
            days,
            sets,
            selectedDiet,
            code
          ) > 0 &&
            !testOrder && (
              <div className="display-flex flex-direction-column spacer-bottom-24">
                <div className="display-flex justify-content-space-between">
                  <span className="body-m color-gray-800">Zniżka</span>

                  <span className="label-m">
                    {parsePrice(
                      getDiscount(
                        getPricePerDayBeforeDiscount(orderForm, sectorId),
                        days,
                        sets,
                        selectedDiet,
                        code
                      )
                    )}{' '}
                    zł
                  </span>
                </div>

                <div className="steps-page-second__summary-wrapper">
                  {discountAmount}
                </div>
              </div>
            )}

          <div className="steps-page__divide" />

          <div className="display-flex justify-content-space-between spacer-top-24">
            <span className="label-m">Do zapłaty</span>

            <div className="display-flex flex-direction-column align-items-end">
              <span className="label-l color-primary">
                {parsePrice(
                  getSelectedSideOrdersPrice(customDays, sets) +
                    getPrice(orderForm, code, sectorId)
                )}{' '}
                zł
              </span>

              {getDiscount(
                getPricePerDayBeforeDiscount(orderForm, sectorId),
                days,
                sets,
                selectedDiet,
                code
              ) > 0 &&
                !testOrder && (
                  <span className="body-m line-through color-gray-400 spacer-top-4">
                    {parsePrice(
                      getPriceWithoutDiscounts(
                        orderForm,
                        days,
                        sets,
                        selectedSideOrders,
                        code,
                        selectedCity,
                        getPricePerDayBeforeDiscount(orderForm, sectorId),
                        selectedDiet
                      )
                    )}{' '}
                    zł
                  </span>
                )}
            </div>
          </div>

          {!isSummaryBarDisplayed && (
            <NextStepButton setValidationStatus={setValidationStatus} />
          )}
        </BoxStep>
      </div>
    </aside>
  );
};

export default SecondStepSideBar;
